import { useCallback, useEffect, useState } from "react";
import axios from "axios";

export const API = "https://api-ru.fynex.cc/api/api";

export const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

/* ---------- статус верификации ---------- */

export const KYC = {
  NONE: "none", // документы не отправлялись
  PENDING: "pending", // на проверке
  VERIFIED: "verified", // пройдена
  REJECTED: "rejected", // отклонена
  UNKNOWN: "unknown", // не удалось получить / незнакомое значение
};

/**
 * Приводит строку из GET /kyc/status к одному из KYC.*
 * Известные значения бэка: "not_added", "waiting", "accepted".
 * Остальные (например, отказ) распознаём по корню слова. Незнакомое
 * значение уходит в console.warn — добавьте его сюда, если увидите.
 */
export function normalizeKycStatus(raw) {
  const s = String(raw ?? "").toLowerCase().trim();
  if (!s || /(not_?add|not_?ver|unver|none|notveryfied)/.test(s)) return KYC.NONE;
  if (/(reject|declin|denied|fail|refus)/.test(s)) return KYC.REJECTED;
  if (/(pend|review|process|wait|moderat|new|sent)/.test(s)) return KYC.PENDING;
  if (/(approv|verif|success|accept|confirm|complete|done)/.test(s)) return KYC.VERIFIED;
  // eslint-disable-next-line no-console
  console.warn("[kyc] неизвестный статус:", raw);
  return KYC.UNKNOWN;
}

export function useKycStatus() {
  const [raw, setRaw] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const refresh = useCallback(() => {
    setLoading(true);
    return axios
      .get(`${API}/kyc/status`, { headers: authHeaders() })
      .then((res) => {
        setRaw(res.data);
        setError(false);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // null — пока идёт первая загрузка
  const status =
    loading && raw === null && !error
      ? null
      : error
      ? KYC.UNKNOWN
      : normalizeKycStatus(raw);

  return { status, raw, loading, error, refresh };
}

/* ---------- профиль ---------- */

export function useMe() {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/users/me`, { headers: authHeaders() })
      .then((res) => setMe(res.data))
      .catch((err) => {
        console.error(err);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, []);

  return { me, loading, error };
}

/* ---------- ошибки ---------- */

// detail от FastAPI бывает массивом [{msg}], строкой или отсутствует
export function extractError(err, fallback = "") {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) {
    const msg = d.map((x) => x?.msg).filter(Boolean).join("; ");
    return msg || fallback;
  }
  if (typeof d === "string") return d;
  return fallback;
}
